module.exports = __webpack_public_path__ + "src/assets/img/lxwm_02@2x.b921cd7c.png";